import { render, staticRenderFns } from "./OrgSaasRedemptionAdminDashboard.vue?vue&type=template&id=1c970945"
import script from "./OrgSaasRedemptionAdminDashboard.vue?vue&type=script&lang=js"
export * from "./OrgSaasRedemptionAdminDashboard.vue?vue&type=script&lang=js"
import style0 from "./OrgSaasRedemptionAdminDashboard.vue?vue&type=style&index=0&id=1c970945&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports